import { useQuery } from 'react-query';

import { EASResult } from 'utils/EASTypes';

import { Backend } from './endpoints';

import { api } from '.';

export const useProducts = () =>
	useQuery('products', () =>
		api().post('admin/products/list').json<EASResult<Backend.Product>>(),
	);

export const updateProduct = (id: string, product: Backend.Product) =>
	api()
		.put(`admin/products/${id}`, { json: product })
		.json<EASResult<Backend.Product>>();
